import { render, staticRenderFns } from "./licenseWarnDataList.vue?vue&type=template&id=f39be1be&scoped=true"
import script from "./licenseWarnDataList.vue?vue&type=script&lang=js"
export * from "./licenseWarnDataList.vue?vue&type=script&lang=js"
import style0 from "./licenseWarnDataList.vue?vue&type=style&index=0&id=f39be1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39be1be",
  null
  
)

export default component.exports